<template>
  <a class="dropdown-item" @click.prevent="$store.commit('layout/toggleTheme')">
    <icon-sun v-if="$store.state.layout.themeBlack" />
    <icon-moon v-else />
    <span>
      {{
        $store.state.layout.themeBlack
          ? $t('header.theme.light')
          : $t('header.theme.dark')
      }}
    </span>
  </a>
</template>

<script>
import IconMoon from '@/components/icons/moon'
import IconSun from '@/components/icons/sun'

export default {
  components: {
    'icon-moon': IconMoon,
    'icon-sun': IconSun,
  },
}
</script>

<style lang="scss">
.theme-selector {
  color: white;

  & svg {
    margin-bottom: 2px;
  }

  &:hover {
    color: #00a6cb;
    background-color: #000;
    cursor: pointer;

    svg path {
      stroke: #00a6cb !important;
    }
  }
}
</style>
